import { render, staticRenderFns } from "./recommendPage.vue?vue&type=template&id=13ba9a92&scoped=true"
import script from "./recommendPage.vue?vue&type=script&lang=js"
export * from "./recommendPage.vue?vue&type=script&lang=js"
import style0 from "./recommendPage.vue?vue&type=style&index=0&id=13ba9a92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba9a92",
  null
  
)

export default component.exports